<header class="govuk-header" role="banner" data-module="govuk-header">
  <div class="idsk-header-web__tricolor"></div>
  <div class="govuk-header__container govuk-width-container">
    <span class="govuk-header__link govuk-header__link--service-name">
      <span class="header-edesk-label">{{ edeskStateService.selectedEdeskShortLabel() ?? 'eDesk Webviewer' }}</span>
      <button
        *ngIf="delegations().length > 1 && edeskStateService.selectedEdeskShortLabel()"
        class="edesk-switch-btn"
        type="button"
        title="Zmeniť eDesk schránku"
        (click)="openEdeskSelector()">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>
    </span>
  </div>
</header>

<router-outlet></router-outlet>

<div class="govuk-width-container govuk-!-margin-top-4 layout-shell" id="main-content" *ngIf="(authService.isAuthenticated$ | async) && edeskStateService.selectedEdeskUri()">

  <div class="mobile-header" *ngIf="!(isDesktop$ | async)">
    <button class="hamburger-button" type="button" (click)="toggleMobileMenu()" aria-label="Otvoriť menu">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 12H21M3 6H21M3 18H21" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <span class="mobile-title">Menu</span>
  </div>

  <div class="mobile-backdrop" *ngIf="mobileMenuOpen && !(isDesktop$ | async)" (click)="closeMobileMenu()"></div>

  <aside class="layout-sidebar" [class.mobile-drawer-open]="mobileMenuOpen" [class.mobile-drawer]="!(isDesktop$ | async)">
    <div class="drawer-header" *ngIf="!(isDesktop$ | async)">
      <h2 class="govuk-heading-s govuk-!-margin-0">Menu</h2>
      <button class="close-icon-button" (click)="closeMobileMenu()">
        <img src="assets/icons/close.svg" alt="" width="24" height="24">
      </button>
    </div>
    <app-folders 
      [selectedFolderId]="selectedFolderId" 
      (folderSelected)="onFolderSelected($event)"
      (composeRequested)="onComposeRequested()">
    </app-folders>
  </aside>

  <main class="layout-content">

    <!-- Loading bar — visible whenever folders or messages are loading -->
    <div class="app-loading-bar" *ngIf="foldersLoading || messagesLoading" aria-label="Načítava sa..." role="status">
      <div class="app-loading-bar__track"></div>
    </div>

    <div class="govuk-!-margin-bottom-2" *ngIf="!selectedMessageId || (isDesktop$ | async)">
      <h1 class="govuk-heading-l govuk-!-margin-bottom-1">{{ selectedFolderName }}</h1>
    </div>

    <!-- Folder error banner — visible on mobile where the sidebar is hidden -->
    <div class="app-folders-error-banner" *ngIf="foldersError && !(isDesktop$ | async)">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <span>{{ foldersError }}</span>
    </div>

    <!-- Filter toggle button for mobile -->
    <button class="filter-toggle-button" *ngIf="(!selectedMessageId || (isDesktop$ | async)) && !isDraftsFolder" (click)="toggleFilterOverlay()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 4h18M3 12h12M3 20h6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Filter
    </button>

    <!-- Backdrop for filter overlay -->
    <div class="filter-backdrop" *ngIf="filterOverlayOpen" (click)="closeFilterOverlay()"></div>

    <div class="app-filters-bar" 
         [class.filter-overlay]="filterOverlayOpen"
         *ngIf="(!selectedMessageId || (isDesktop$ | async)) && !isDraftsFolder">
      
      <!-- Close button for overlay mode -->
      <button class="close-icon-button" (click)="closeFilterOverlay()">
        <img src="assets/icons/close.svg" alt="" width="24" height="24">
      </button>

      <div class="filter-group">
        <label class="govuk-label govuk-!-margin-bottom-0 govuk-!-margin-right-2" for="globalSearch">Hľadať:</label>
        <input id="globalSearch" class="govuk-input govuk-input--width-20" type="text"
               [value]="filterQuery" 
               (input)="updateFilter($event)"
               placeholder="Predmet, odosielateľ...">
      </div>
      
      <div class="filter-group">
         <select class="govuk-select" [value]="pageSize" (change)="updatePageSize($event)">
            <option [value]="10">10 na stranu</option>
            <option [value]="20">20 na stranu</option>
            <option [value]="30">30 na stranu</option>
         </select>
         
         <!-- Desktop: Refresh button, Mobile: Clear button -->
         <button class="govuk-button govuk-button--secondary govuk-!-margin-bottom-0 filter-action-desktop" (click)="refreshList()">
           Obnoviť
         </button>
         <button class="govuk-button govuk-button--secondary govuk-!-margin-bottom-0 filter-action-mobile" (click)="clearFilters()">
           Zrušiť filter
         </button>
      </div>
    </div>

    <div class="split-view">
      
      <div class="split-list" [class.hidden-mobile]="selectedMessageId && !(isDesktop$ | async)">
        <app-draft-list 
             #draftListComponent
             *ngIf="isDraftsFolder"
             [pageSize]="pageSize"
             (draftSelected)="onDraftSelected($event)">
        </app-draft-list>
        <app-message-list 
             *ngIf="!isDraftsFolder"
             [folderId]="selectedFolderId" 
             [selectedMessageId]="selectedMessageId"
             [query]="filterQuery"
             [pageSize]="pageSize"
             (messageSelected)="onMessageSelected($event)">
        </app-message-list>
      </div>

      <div class="split-detail" *ngIf="selectedMessageId || (isDesktop$ | async)">
         <div class="mobile-back-bar" *ngIf="!(isDesktop$ | async)">
           <button class="mobile-back-button" (click)="clearMessageSelection()">
             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 12H5M12 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
             Späť na zoznam
           </button>
         </div>
         <app-message-detail [messageId]="selectedMessageId" [messageClass]="selectedMessageClass"></app-message-detail>
      </div>

    </div>
  </main>
</div>

<!-- Loading mailboxes — shown briefly while delegations are being fetched -->
<div class="govuk-width-container govuk-!-margin-top-6"
     *ngIf="(authService.isAuthenticated$ | async) && !delegationsLoaded()">
  <p class="govuk-body" role="status">Načítavam schránky…</p>
</div>

<!-- No usable eDesk mailbox — delegations loaded, but nothing is selectable
     (user has no delegation, or all delegations are expired/revoked) -->
<div class="govuk-width-container govuk-!-margin-top-6"
     *ngIf="(authService.isAuthenticated$ | async) && delegationsLoaded() && !edeskStateService.selectedEdeskUri() && !showEdeskSelector()">
  <div class="govuk-notification-banner" role="region" aria-labelledby="no-edesk-title" data-module="govuk-notification-banner">
    <div class="govuk-notification-banner__header">
      <h2 class="govuk-notification-banner__title" id="no-edesk-title">Upozornenie</h2>
    </div>
    <div class="govuk-notification-banner__content">
      <h3 class="govuk-heading-m govuk-!-margin-bottom-2">Žiadna dostupná schránka</h3>
      <p class="govuk-body" *ngIf="delegations().length === 0">
        Vaše konto nemá priradené žiadne zastupovanie (eDesk schránku). Ak ste prístup očakávali,
        zastupovanie ešte nemuselo byť zriadené — obráťte sa na správcu.
      </p>
      <p class="govuk-body" *ngIf="delegations().length > 0">
        Žiadna z vašich schránok nie je momentálne dostupná. Vaše zastupovanie mohlo vypršať
        alebo bolo zrušené. Obráťte sa na správcu alebo to skúste neskôr.
      </p>
      <button class="govuk-button govuk-button--secondary govuk-!-margin-bottom-0" type="button" (click)="logout()">
        Odhlásiť sa
      </button>
    </div>
  </div>
</div>

<!-- Compose Dialog - Rendered at root level to appear outside mobile drawer -->
<app-compose-dialog
  *ngIf="authService.isAuthenticated$ | async"
  [open]="composeOpen"
  [recipients]="recipients()"
  [autoCloseOnSuccess]="false"
  (close)="closeCompose()"
  (sent)="onMessageSent($event)">
</app-compose-dialog>

<!-- eDesk Selector - shown when user has multiple eDesks to choose from -->
<app-edesk-selector
  *ngIf="showEdeskSelector()"
  [delegations]="delegations()"
  (edeskSelected)="onEdeskSelected($event)"
  (cancelled)="showEdeskSelector.set(false)">
</app-edesk-selector>